<template>
	<div id="index">
		<Singinheader :headertext="texted"></Singinheader>
		<div class="content">
			<div class="settledbaner" :style="backgroundimg">
				<h4>申请成为商家</h4>
				<p>成为分销商后卖出商品，您可以获得佣金</p>
			</div>
			<div class="settledcon">
				<div class="settledconed">
					<div class="settlednav">
						<ul class="clearfloat">
							<li :class="{'active':status == 1}">
								<div class="settlednavtext">
									<span>1</span>
									<strong>填写信息</strong>
								</div>
							</li>
							<li :class="{'active':status == 3}">
								<div class="settlednavtext">
									<span>2</span>
									<strong>等待审核</strong>
								</div>
							</li>
							<li :class="{'active':status == 2}" v-if="status != 4">
								<div class="settlednavtext">
									<span>3</span>
									<strong>审核成功</strong>
								</div>
							</li>
							<li :class="{'active':status == 4}" v-if="status == 4">
								<div class="settlednavtext">
									<span>3</span>
									<strong>审核失败</strong>
								</div>
							</li>
							<li v-if="status == 2 && is_money == 0">
								<div class="settlednavtext">
									<span>4</span>
									<strong>缴纳保障金</strong>
								</div>
							</li>
						</ul>
					</div>
					<div class="settledconter" v-if="status == 1">
						<div class="settledlist clearfloat">
							<span>商户类型：</span>
							<div class="settledlistright clearfloat">
								<p>
									<template v-if="mch_type == 1">入驻商</template>
									<template v-if="mch_type == 2">o2o</template>
									<template v-if="mch_type == 3">供货商</template>
								</p>
							</div>
						</div>
						<div class="settledlist clearfloat">
							<span><i>*</i>联系人：</span>
							<div class="settledlistright clearfloat">
								<input type="text" v-model="realname">
							</div>
						</div>
						<div class="settledlist clearfloat">
							<span><i>*</i>联系电话：</span>
							<div class="settledlistright clearfloat">
								<input type="text" v-model="tel" maxlength="11">
							</div>
						</div>
						<div class="settledlist clearfloat">
							<span>微信号：</span>
							<div class="settledlistright clearfloat">
								<input type="text" v-model="wechat_name">
							</div>
						</div>
						<div class="settledlist clearfloat">
							<span><i>*</i>店铺昵称：</span>
							<div class="settledlistright clearfloat">
								<input type="text" v-model="name">
							</div>
						</div>
						<div class="settledlist clearfloat">
							<span><i>*</i>所在地区：</span>
							<div class="settledlistright clearfloat">
								<el-cascader :options="district_list" :props="{value:'id',label:'name',children: 'list'}" v-model="address_province"></el-cascader>
							</div>
						</div>
						<div class="settledlist clearfloat">
							<span><i>*</i>详细地址：</span>
							<div class="settledlistright clearfloat">
								<input type="text" v-model="address">
							</div>
						</div>
						<div class="settledlist clearfloat">
							<span><i>*</i>商户等级：</span>
							<div class="settledlistright clearfloat">
								<el-select v-model="mch_common_cat" placeholder="请选择" @change="selectChange">
									<el-option v-for="item in apply_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</div>
						</div>
						<div class="settledlist clearfloat">
							<span><i>*</i>客服电话：</span>
							<div class="settledlistright clearfloat">
								<input type="text" v-model="service_tel">
							</div>
						</div>
						<!-- 后台添加模块 -->
						<template v-for="(item,index) in list">
							<!-- 时间 -->
							<div class="settledlist clearfloat" v-if="item.type == 'time'">
								<span><i v-if="item.required == 1">*</i>{{item.name}}：</span>
								<div class="settledlistright clearfloat">
									<el-time-picker v-model="item.default" placeholder="请选择时间"></el-time-picker>
								</div>
							</div>
							<!-- 日期 -->
							<div class="settledlist clearfloat" v-if="item.type == 'date'">
								<span><i v-if="item.required == 1">*</i>{{item.name}}：</span>
								<div class="settledlistright clearfloat">
									<el-date-picker v-model="item.default" type="date" placeholder="请选择日期"></el-date-picker>
								</div>
							</div>
							<!-- 单行 -->
							<div class="settledlist clearfloat" v-if="item.type == 'text'">
								<span><i v-if="item.required == 1">*</i>{{item.name}}：</span>
								<div class="settledlistright clearfloat">
									<input type="text" v-model="item.default" :placeholder="item.tip">
								</div>
							</div>
							<!-- 多行 -->
							<div class="settledlist clearfloat" v-if="item.type == 'textarea'">
								<span><i v-if="item.required == 1">*</i>{{item.name}}：</span>
								<div class="settledlistright clearfloat">
									<textarea v-model="item.default" :placeholder="item.tip"></textarea>
								</div>
							</div>
							<!-- 单选 -->
							<div class="settledlist clearfloat" v-if="item.type == 'radio'">
								<span><i v-if="item.required == 1">*</i>{{item.name}}：</span>
								<div class="settledlistright clearfloat">
									<template v-for="(value, key) in item.default_list">
										<el-radio :label="key" v-model="radio" @change="inputGroup(index,key)">{{value.name}}</el-radio>
									</template>
								</div>
							</div>
							<!-- 多选 -->
							<div class="settledlist clearfloat" v-if="item.type == 'checkbox'">
								<span><i v-if="item.required == 1">*</i>{{item.name}}：</span>
								<div class="settledlistright clearfloat">
									<template v-for="(value, key) in item.default_list">
										<el-checkbox :label="value.name" v-model="check_list" @change="inputGroup(index,key)">{{value.name}}</el-checkbox>
									</template>
								</div>
							</div>
							<!-- 上传图片 -->
							<div class="settledlist settledlistlast clearfloat" v-if="item.type == 'uploadImg'">
								<span><i v-if="item.required == 1">*</i>{{item.name}}：</span>
								<div class="settledlistright clearfloat">
									<el-upload class="avatar-uploader" action="String" :on-change="(file, fileList) => {handleChange(file, fileList, index)}"
									 :on-remove="(file, fileList)=>{handleRemove(file, fileList, index)}" list-type="picture-card" :auto-upload="false"
									 accept="image/*" :limit="imgLimit" :file-list="productImgs" :before-upload="beforeAvatarUpload" :on-exceed="handleExceed"
									 :on-error="imgUploadError">
										<div class="uploader-default">
											<img class="img-default" src="../../assets/images/icon_camera.png" alt="">
											<p>{{item.tip || item.name}}</p>
										</div>
									</el-upload>
								</div>
							</div>
						</template>
						<div class="settledlist settledlisteds">
							<button @click="submit()">提交申请</button>
						</div>
					</div>
					<div class="inreview">
						<!-- 审核中 -->
						<template v-if="status == 3">
							<div class="inreviewimg">
								<img class="img-default" src="../../assets/images/iconiner.png" alt="">
							</div>
							<div class="inreviewtext">
								<p>您的申请已提交，系统会在审核后通知您，请留意。</p>
								<router-link to="/" replace>返回首页</router-link>
							</div>
						</template>
						<!-- 审核成功 -->
						<template v-if="status == 2">
							<div class="inreviewimg">
								<img class="img-default" src="../../assets/images/iconcg.png" alt="">
							</div>
							<div class="inreviewtext">
								<template v-if="is_money == 0">
									<p>您的申请已通过，请您缴纳保障金<i v-text="money"></i>元</p>
									<router-link :to="{ path: 'payment', query: { mch_type: mch_type }}" replace>去缴纳保障金</router-link>
								</template>
								<template v-if="is_money == 1">
									<p>您的申请已通过</p>
									<router-link to="/" replace>去首页</router-link>
								</template>
							</div>
						</template>
						<!-- 审核失败 -->
						<template v-if="status == 4">
							<div class="inreviewimg">
								<img class="img-default" src="../../assets/images/iconwtg.png" alt="">
							</div>
							<div class="inreviewtext">
								<p>您的申请未通过，请重新填写您的申请资料</p>
								<span @click="againApply()">再次申请</span>
							</div>
						</template>

					</div>
				</div>
			</div>
		</div>
		<Foot></Foot>
	</div>
</template>

<script>
	import Singinheader from "../signup/components/singinheader.vue";
	import Foot from "@/components/foot/foot";
	export default {
		components: {
			Singinheader,
			Foot,
		},
		data() {
			return {
				texted: "商家入驻",
				backgroundimg: {
					backgroundImage: "url(" + require("../../assets/images/settled.png") + ")",
				},
				mch_type: this.$route.query.mch_type,
				list: [],
				district_list: [], //省市区列表
				apply_list: [], //商户等级列表
				radio: 3,
				check_list: [],
				imgLimit: 1,
				productImgs: [],
				realname: '', //联系人姓名
				tel: '', //联系人手机号
				name: '', //店铺名称
				address: '', //详细地址
				service_tel: '', //客服电话
				wechat_name: '', //微信号
				longitude: 116.40717,
				latitude: 39.90469,
				mch_common_cat: '',
				mch_common_cat_id: '', //商户等级id
				address_province: [], //选中省市区id
				money: '', //需要缴纳的保证金
				is_money: 1, // 0需要缴纳保证金 1不需要缴纳保证金 
				status: '', //审核状态 1入驻申请 2审核成功 3审核中 4审核失败
			};
		},
		created() {
			this.getMyShop();
		},
		methods: {
			// 获取商户状态
			getMyShop() {
				this.$loading();
				let params = {
					mch_type: this.mch_type
				}
				this.$api.myShop(params).then(res => {
					this.$loading().close();
					if (res.code == 0) { //商家入驻审核成功
						this.status = 2;
						this.is_money = 1;
					}
				}).catch(err => {
					this.$loading().close();
					if (err.code == 1) { //请先入驻
						this.againApply();
					} else if (err.code == 2) { //商家入驻审核成功但需要缴纳保证金
						this.status = 2;
						this.is_money = 0;
						this.mchMoney();
					} else if (err.code == 3) { //商家入驻审核中
						this.status = 3;
					} else if (err.code == 4) { //商家入驻审核失败
						this.status = 4;
					}
				});
			},
			// 审核失败再次申请
			againApply() {
				this.status = 1;
				this.getDistrict();
				this.getList();
				this.getApply();
			},
			// 获取保证金金额
			mchMoney() {
				let params = {
					mch_type: this.mch_type,
				}
				this.$api.mchMoney(params).then(res => {
					this.money = res.data;
				}).catch(err => {
					this.common.message(this, err)
				});
			},
			// 获取省市区
			getDistrict() {
				let that = this;
				this.$api.district().then(res => {
					that.district_list = res.data;
				}).catch(err => {
					console.log(err);
				});
			},
			// 获取商户等级
			getApply() {
				let that = this;
				this.$api.apply().then(res => {
					that.apply_list = res.data.mch_common_cat_list;
					console.log(that.apply_list)
				}).catch(err => {
					console.log(err);
				});
			},
			// 获取后台设置的模板信息
			getList() {
				let params = {
					mch_type: this.mch_type
				};
				this.$api.mchMessage(params).then((res) => {
					this.list = res.data;
				}).catch((err) => {
					// this.common.message(this, err);
				});
			},
			// 选择框
			inputGroup(index, key) {
				if (this.list[index].default_list[key].is_selected == 0) {
					this.list[index].default_list[key].is_selected = 1;
				} else {
					this.list[index].default_list[key].is_selected = 0;
				}
			},
			// 选择图片
			handleChange(file, fileList, index) {
				const formData = new FormData();
				formData.append("image", fileList[0].raw);
				let config = {
					headers: {
						"Content-Type": "mutipart/form-data"
					},
				};
				this.$api.uploadImage(formData, config).then((res) => {
					this.list[index].default = res.data.url;
					// this.$set(this.list[index], "default", res.data.url)
				}).catch((err) => {
					this.common.message(this, err)
				});
			},
			// 删除图片调用
			handleRemove(file, fileList, index) {
				this.list[index].default = "";
			},
			// 图片上传失败调用
			imgUploadError(err, file, fileList) {
				this.$message.error("上传图片失败!");
			},
			//文件上传之前调用做一些拦截限制
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 2;
				if (!isLt2M) {
					this.$message.error("上传图片大小不能超过 2MB!");
				}
				return isLt2M;
			},
			//图片上传超过数量限制
			handleExceed(files, fileList) {
				this.$message.error("上传图片不能超过1张!");
			},
			// 商家等级
			selectChange(id) {
				this.mch_common_cat_id = id;
			},
			// 提交申请
			submit() {
				if (!this.realname) {
					this.$message.warning("请输入联系人名称");
					return false;
				} else if (!(/^1[3456789]\d{9}$/.test(this.tel))) {
					this.$message.warning("请输入正确的手机号");
					return false;
				} else if (!this.name) {
					this.$message.warning("请输入店铺名称");
					return false;
				} else if (!this.address_province.length) {
					this.$message.warning("请选择所在地区");
					return false;
				} else if (!this.address) {
					this.$message.warning("请输入详细地址");
					return false;
				} else if (!this.mch_common_cat_id) {
					this.$message.warning("请选择商户等级");
					return false;
				} else if (!this.mch_common_cat_id) {
					this.$message.warning("请选择商品等级");
					return false;
				} else if (!this.service_tel) {
					this.$message.warning("请输入客服电话");
					return false;
				}
				// 验证后台设置必填项
				let list = this.list;
				for (let i in list) {
					if (list[i].required == 1) {
						if (list[i].type == "radio" || list[i].type == "checkbox") {
							let type = false;
							for (let j in list[i].default_list) {
								if (list[i].default_list[j].is_selected == 1) {
									type = true;
								}
							}
							if (!type) {
								this.$message.warning('请选择' + list[i].name);
								return false
							}
						} else if (!list[i].default || list[i].default == null) {
							if (list[i].type == "time" || list[i].type == "date") {
								this.$message.warning('请选择' + list[i].name);
								return false;
							} else if (list[i].type == "uploadImg") {
								this.$message.warning('请上传' + list[i].name);
								return false;
							} else {
								this.$message.warning('请填写' + list[i].name);
								return false;
							}
						}
					}
				}
				let params = {
					realname: this.realname,
					tel: this.tel,
					name: this.name,
					province_id: this.address_province[0],
					city_id: this.address_province[1],
					district_id: this.address_province[2],
					address: this.address,
					mch_common_cat_id: this.mch_common_cat_id,
					service_tel: this.service_tel,
					mch_type: this.mch_type,
					longitude: this.longitude,
					latitude: this.latitude,
					wechat_name: this.wechat_name,
					modular: JSON.stringify(this.list),
				}
				this.$api.applySubmit(params).then((res) => {
					this.$message.success(res.msg);
					this.status = 3;
				}).catch((err) => {
					this.common.message(this, err)
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
	.content {
		width: 100%;
		padding-bottom: 60px;
		box-sizing: border-box;
		background: #F2F2F2;

		.settledbaner {
			width: 100%;
			height: 369px;
			padding-top: 62px;
			box-sizing: border-box;
			background-position: center;
			background-repeat: no-repeat;

			h4 {
				font-size: 67px;
				color: #fff;
				text-align: center;
				line-height: 94px;
				text-shadow: 0px 2px 10px rgba(174, 10, 10, 0.44);
				margin-bottom: 4px;
			}

			p {
				font-size: 24px;
				color: #fff;
				text-align: center;
				line-height: 24px;
				font-weight: 400;

			}
		}

		.settledcon {
			width: 100%;

			.settledconed {
				width: 990px;
				background: #fff;
				padding: 0 56px;
				box-sizing: border-box;
				margin: -80px auto 0;

				.settlednav {
					width: 100%;
					height: 80px;
					border-bottom: 1px solid #EBEBEB;

					ul {
						display: table;
						margin: 0 auto;

						li {
							float: left;
							position: relative;
							line-height: 80px;
							margin-right: 60px;

							&:last-child {
								margin-right: 0;
							}

							&.active .settlednavtext::before {
								width: 100%;
							}

							&.active .settlednavtext span {
								background: #FF9010;
								color: #fff;
							}

							&.active .settlednavtext strong {
								color: #FF9010;
							}

							.settlednavtext {
								position: relative;

								&::before {
									content: '';
									width: 0%;
									height: 1px;
									background: #FF9010;
									position: absolute;
									bottom: 0;
									left: 0;
								}

								span {
									display: inline-block;
									width: 24px;
									height: 24px;
									border-radius: 50%;
									text-align: center;
									line-height: 24px;
									font-size: 14px;
									color: #999;
									background: #EBEBEB;
									margin-right: 12px;
								}

								strong {
									display: inline-block;
									font-size: 12px;
									color: #999;
									font-weight: 400;
								}
							}
						}
					}
				}

				.settledconter {
					width: 100%;
					padding: 52px 130px 72px 130px;
					box-sizing: border-box;

					.settledlist {
						width: 100%;
						margin-bottom: 24px;
						display: flex;
						align-items: center;

						span {
							float: left;
							max-width: 100px;
							width: 100px;
							text-align: right;
							font-size: 14px;
							color: #333;
							font-weight: 400;
							line-height: 32px;
							margin-right: 16px;

							i {
								padding: 0 3px;
								font-style: normal;
								color: #FF0E25;
							}
						}

						.settledlistright {
							float: left;
							width: 490px;

							.el-radio {
								padding: 8px 0;
							}

							.el-checkbox {
								padding: 6.5px 0;
							}

							.el-date-editor.el-input,
							.el-date-editor.el-input__inner {
								width: 300px !important;
							}

							// .uploader-default
							.el-upload--picture-card {
								width: 245px;
								height: 147px;
								border: 1px dashed #ccc;
								border-radius: 10px;

								img {
									width: 40px;
									height: 32px;
									margin: 40px auto 0;
								}

								p {
									color: #B0B0B1;
									text-align: center;
									margin-top: 16px;
									line-height: 14px;
								}
							}

							p {
								font-size: 14px;
								color: #333;
								line-height: 32px;
							}

							ul {
								li {
									float: left;
									width: 157px;
									height: 60px;
									border: 1px solid #EBEBEB;
									border-radius: 2px;
									cursor: pointer;
									text-align: center;
									padding-top: 13px;
									box-sizing: border-box;
									position: relative;
									margin-right: 16px;

									&:last-child {
										margin-right: 0;
									}

									&.active {
										border-color: #FF0E25;
									}

									&.active b {
										display: block;
									}

									i {
										display: inline-block;
										width: 32px;
										height: 32px;
										border-radius: 50%;
										margin-right: 8px;

										img {
											display: block;
											width: 100%;
											border-radius: 50%;
										}
									}

									p {
										display: inline-block;
										font-size: 16px;
										color: #333;
										font-weight: 400;
										vertical-align: 8px;
									}

									b {
										display: none;
										width: 12px;
										height: 12px;
										position: absolute;
										bottom: -1px;
										right: -1px;

										img {
											display: block;
										}
									}
								}
							}

							input[type="text"] {
								width: 300px;
								height: 32px;
								border: 1px solid #EBEBEB;
								padding: 0 10px;
								font-size: 14px;
								color: #333;
								box-sizing: border-box;
								outline: none;
								border-radius: 2px;
								transition: .5s;
								-moz-transition: .5s;
								-webkit-transition: .5s;
								-o-transition: .5s;

								&:focus {
									border-color: #FF0E25;
								}
							}

							textarea {
								width: 300px;
								height: 100px;
								border: 1px solid #EBEBEB;
								padding: 10px;
								font-size: 14px;
								color: #333;
								box-sizing: border-box;
								outline: none;
								border-radius: 2px;
								transition: .5s;
								-moz-transition: .5s;
								-webkit-transition: .5s;
								-o-transition: .5s;
								resize: none;

								&:focus {
									border-color: #FF0E25;
								}
							}

							.settledup {
								width: 80px;
								height: 80px;
								border: 1px solid #EBEBEB;
								border-radius: 2px;
								line-height: 78px;
								text-align: center;
								box-sizing: border-box;

								strong {
									font-size: 45px;
									color: #EBEBEB;
									font-weight: 100;
								}
							}

							.settledlistrighted {
								.settledimg {
									float: left;
									width: 245px;
									height: 147px;
									border-radius: 10px;
									margin-right: 13px;
									margin-bottom: 24px;

									&:nth-child(2n) {
										margin-right: 0;
									}

									img {
										display: block;
									}
								}
							}
						}

						button {
							width: 120px;
							height: 40px;
							background: linear-gradient(270deg, #FF0E25 0%, #FF9010 100%);
							background: -moz-linear-gradient(270deg, #FF0E25 0%, #FF9010 100%);
							background: -webkit-gradient(270deg, #FF0E25 0%, #FF9010 100%);
							background: -ms-linear-gradient(270deg, #FF0E25 0%, #FF9010 100%);
							filter: progid:DXImageTransform.Microsoft.gradient(GradientType=1, startColorstr=#FF0E25, endColorstr=#FF9010);
							border-radius: 2px;
							font-size: 14px;
							color: #fff;
							font-weight: 500;
							border: 0;
							outline: none;
							cursor: pointer;
							margin-left: 106px;
							transition: .5s;
							-moz-transition: .5s;
							-webkit-transition: .5s;
							-o-transition: .5s;

							&:hover {
								box-shadow: 0 5px 10px rgba(215, 119, 8, 0.5);
							}
						}
					}

					.settledlisteds {
						margin-bottom: 0;
					}

					.settledlisted {
						span {
							line-height: 60px;
						}
					}

					.settledlistlogo {
						span {
							line-height: 80px;
						}
					}

				}

				//审核中
				.inreview {
					width: 100%;
					background: #fff;
					padding: 85px 40px 135px 40px;
					box-sizing: border-box;

					.inreviewimg {
						width: 100px;
						height: 100px;
						border-radius: 50%;
						margin: 0 auto 24px;

						img {
							display: block;
							border-radius: 50%;
						}
					}

					.inreviewtext {
						width: 100%;

						p {
							font-size: 12px;
							color: #333;
							font-weight: 400;
							line-height: 12px;
							text-align: center;
							margin-bottom: 30px;

							i {
								font-style: normal;
								color: #ff0e25;
								padding: 0 2px;
							}
						}

						a,
						span {
							font-size: 12px;
							color: #0E9CFF;
							text-align: center;
							font-weight: 400;
							line-height: 12px;
							display: table;
							margin: 0 auto;
							cursor: pointer;
						}
					}
				}
			}
		}
	}
</style>
